/**
 * This file contains the queries that aren made outside the hasura regular provider
 * only for special cases
 */
import { gql } from '@apollo/client'

export const countSummaryQuery = `
    query countSummary {
        advancedCount: invoiceadvance_view_invoice_advance_summary_aggregate
        (where: {state: {_in: ["advanced", "requested", "pendingReview", "approved", "pendingAdvance"]}}) {
            aggregate {
                count
            }
        }
        lateCount: invoiceadvance_view_invoice_advance_summary_aggregate
        (where: {state: {_eq: "late"}}) {
            aggregate {
                count
            }
        }
        delayedCount: invoiceadvance_view_invoice_advance_summary_aggregate
        (where: {state: {_eq: "delayed"}}) {
            aggregate {
                count
            }
        }
        paidCount: invoiceadvance_view_invoice_advance_summary_aggregate
        (where: {state: {_in: ["paid", "settle", "settlementCompleted"]}}) {
            aggregate {
                count
            }
        }
    }
`

export const processInvoiceAdvanceBulkRequest = gql`
  mutation processInvoiceAdvanceBulkRequest(
    $command: JSON = ""
    $commandName: String = ""
  ) {
    invoiceAdvanceMutation(command: $command, commandName: $commandName) {
      error {
        message
        name
      }
      data
      success
    }
  }
`

export const customerIdQuery = `
  query ($email: String!) {
    customer_customer(where: { email: { _eq: $email } }) {
      id
      email
      first_name
      last_name
      tax_id
    }
  }
`

export const businessNameQuery = `
  query ($taxId: String!) {
    customer_business(where: { tax_id: { _eq: $taxId } }) {
        name
    }
  }
`

export const invoiceAdvanceDenormalizedEntries = (
  field = 'invoice_advance_id'
) => `
  query invoiceAdvanceViewEntries($${field}: [String!]) {
    invoiceadvance_view_denormalized_entries(where: {${field}: {_in: $${field}}}) {
      Date
      Status
      Type
      amount
      business_id
      customer_id
      directional_direction
      invoice
      subType
      reference
      invoice_advance_id
      state
    }
  }
`

export const invoiceAdvanceTotalUsedAggregate = `
query creditLinesIATotalUsed($creditLineId: String = "") {
  invoiceadvance_view_invoice_advance_summary_aggregate(where: { credit_line_id: { _eq: $creditLineId }, advance_date: { _is_null: false }}) {
    aggregate {
      sum {
        repaid_amount
        allocated
      }
    }
  }
}
`

export const invoiceAdvanceTotalAllocatedAggregate = `
query creditLinesIATotalUsed($creditLineId: String = "") {
  invoiceadvance_view_invoice_advance_summary_aggregate(where: {credit_line_id: {_eq: $creditLineId}, paid_at: {_is_null: true}, advance_date: { _is_null: false }}) {
    aggregate {
      sum {
        allocated
      }
    }
  }
}
`

export const collectionAllocationsSummary = `
  query MyQuery($deposit_id: String = "") {
    collection_view_allocations_summary(where: { deposit_id: { _eq: $deposit_id } }) {
      amount
      deposit_id
      invoice_advance_id
      invoice_amount
      invoice_id
      type
    }
  }
`

export const exportInvoiceAdvance = (customer_id, buyer_name) => `
  query MyQuery($customer_id: String = "", $buyer_name: String) {
    invoiceadvance_view_invoice_advance_summary(where: { customer_id: { _eq: "${customer_id}" } ${
  buyer_name ? `, buyer_name: {_eq: "${buyer_name}" }` : ''
} }) {
      state
      id
      advance_amount
      advance_date
      advance_duration
      advance_rate
      business_name
      businessProductAdvanceRate
      business_product_id
      buyer_name
      credit_line_id
      current_remaining_amount
      customer_id
      due_date
      document_locations
      duration
      early_late_fee
      effective_advance
      effective_collection
      effective_settlement
      fee_at_due
      fee_to_pay
      gracePeriod
      grossRate
      interestRatePerPeriod
      invoice
      invoice_amount
      issue_date
      lateFeeMultiplier
      maxDays
      maxValue
      net_rate
      overdraft
      payment_bulk_id
      paid_at
      post_adjustment
      pre_adjustment
      purchase_order
      received_amount
      repayment_amount
      request_bulk_id
      requested_at
      settled_at
    }
  }
`

export const exportPayments = (customer_id) => `
  query MyQuery($customer_id: String) {
    invoiceadvance_view_denormalized_payments(where: {customer_id: {_eq: "${customer_id}"}}) {
      Importer
      Type
      amount
      company_name
      customer_id
      date
      exporter
      reference
      origin
      remaining_balance
      status
      total_entries
    }
  }
`

export const exportInvoiceAdvanceDenormalizedEntries = (customer_id) => `
  query invoiceAdvanceViewEntries($customer_id: [String!]) {
    invoiceadvance_view_denormalized_entries(where: {customer_id: {_in: "${customer_id}"}, subType: {_neq: "PassThrough"}}) {
      Date
      Status
      Type
      amount
      business_id
      customer_id
      directional_direction
      invoice
      subType
      reference
      invoice_advance_id
      invoiceAdvance {
        buyer
      }
      state
    }
  }
`

export const invoiceAdvanceInvoiceCount = `
  query MyQuery($credit_line_id: String = "") {
    invoiceadvance_view_invoice_advance_summary_aggregate(where: { credit_line_id: { _eq: $credit_line_id },
        }) {
      aggregate {
        count
      }
    }
  }
`
